import { CitiesSearchArgs } from 'types/api/arguments/cities-search-args'
import { CitiesSearchResp } from 'types/api/response/cities-search-resp'

import { api } from './api'

export const searchCities = ({ countryId, searchText }: CitiesSearchArgs) =>
  api.get<CitiesSearchResp>(`/countries/${countryId}/cities`, {
    params: { search_text: searchText || '' },
  })
